import React from "react";
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import validator from 'validator';
import { Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { utils, brand, BE_API_AUTH, DOMAIN_FE } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import InputComponent from "../../components/general/InputComponent";

const ForgotPasswordFirstStep = ({ stateShow, fnHide }) => {

    const mountedRef = React.useRef(true);

    const notificationId = React.useRef({
        errorSubmitEmail: 'ForgotPasswordFirstStep-2',
    })

    const [data, setData] = React.useState({
        forgotPassword: {
            valueEmail: '',
            valueEmailError: '',
            submitLoading: false
        },

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);

    const submitForgotPassword = () => {
        setData(d => ({ ...d, forgotPassword: { ...d.forgotPassword, valueEmailError: '' } }));

        if (validator.isEmpty(data.forgotPassword.valueEmail, { ignore_whitespace: true })) {
            setData(d => ({ ...d, forgotPassword: { ...d.forgotPassword, valueEmailError: 'Isi email terlebih dahulu.' } }));
        } else if (!validator.isEmail(data.forgotPassword.valueEmail)) {
            setData(d => ({ ...d, forgotPassword: { ...d.forgotPassword, valueEmailError: 'Format Email Tidak Valid' } }));
        } else {
            setData(d => ({ ...d, forgotPassword: { ...d.forgotPassword, submitLoading: true } }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('email', data.forgotPassword.valueEmail);
            formDT.append('kode', uuidv4());
            formDT.append('slug_link', utils.linkVerifikasiSlug);
            formDT.append('domain_fe', DOMAIN_FE);
            formDT.append('nama_perusahaan', brand.longName);

            axios({
                method: 'post',
                url: BE_API_AUTH + '/forgot_password_first_step',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, forgotPassword: { ...d.forgotPassword, submitLoading: false } }));
                fnHide();

                if (response.data.flag_status === 'isset') {
                    setData(d => ({
                        ...d,
                        forgotPassword: { ...d.forgotPassword, valueEmail: '' },
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: false,
                            content: 'Link verifikasi telah dikirim ke email Anda. Klik link tersebut untuk mereset username dan password Anda.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'email-tidak-ada') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: false,
                            content: 'Email tidak terdaftar pada aplikasi.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'email-not-sent') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: false,
                            content: 'Email tidak terkirim. Silahkan ulangi proses.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitEmail,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, forgotPassword: { ...d.forgotPassword, submitLoading: false } }));
                fnHide();

                notifications.show({
                    id: notificationId.current.errorSubmitEmail,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            })
        }
    }

    return (
        <React.Fragment>
            <ModalTakeAction
                stateShow={stateShow}
                fnHide={fnHide}

                stateHideOnClickOutSide={true}
                stateTitle={String('Reset Username dan Password').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Reset'
                stateButtonActionPx='md'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.forgotPassword.submitLoading}
                fnButtonAction={submitForgotPassword}
            >
                <InputComponent
                    stateId='forgot-password-1'
                    stateWithAsterisk={false}
                    stateLabelFullWidth={true}
                    stateLabel={
                        <Text fw='normal'>
                            Masukkan alamat email Anda yang telah didaftarkan pada aplikasi. Selanjutnya link verifikasi akan dikirim melalui email ini untuk melanjutkan langkah reset username dan password ini.
                        </Text>
                    }
                    stateDescription=''
                    statePlaceHolder='Email'
                    stateReadOnly={false}
                    stateValue={data.forgotPassword.valueEmail}
                    stateError={data.forgotPassword.valueEmailError}
                    stateMB="0"
                    fnOnChange={(e) => setData(d => ({ ...d, forgotPassword: { ...d.forgotPassword, valueEmail: e.target.value } }))}
                />
            </ModalTakeAction>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default React.memo(ForgotPasswordFirstStep);